
import http from '@/utils/http';
import {
  VersionType,
} from '@/pages/home/types/versionPopup';

export const getVersionDetailInfo = (data: any) => {
  const payload = {
    ...data,
    group: 'monthly_databrain_iterative_update.config',
  };
  return http({
    url: '/api/v1/permission/rainbow',
    method: 'post',
    data: payload,
  });
};
/**获取所有版本信息 */
export const getVersionInfo: (payload: any) => Promise<any> = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/versionList',
    method: 'post',
    data: payload,
  }) as Promise<any>;
};
/**获取是否有最新版本自动弹窗 */
export const getNewVersion: (payload: any) => Promise<VersionType> = (payload) => {
  return http({
    url: '/api/v1/homepage/pc/newVersion',
    method: 'post',
    data: payload,
  }) as Promise<VersionType>;
};
/**版本已读接口 */
export const versionVisit = (payload: any) => {
  return http({
    url: '/api/v1/homepage/pc/versionVisit/add',
    method: 'post',
    data: payload,
  });
};